import React from 'react';
import './App.css';

const TermsAndConditions = () => {
  return (
    <div className="terms-container">
      <h1 className="terms-heading">Terms and Conditions</h1>
      <p><strong>Last updated:</strong> June 1, 2024</p>

      <h2 className="terms-subheading">Runner  Service</h2>
      <ol>
        <li>
          <strong>Service Agreement:</strong> By using our laundry service, you agree to these terms and conditions.
        </li>
        <li>
          <strong>Item Handling:</strong>
          <ul>
            <li>
              <strong>Inspection:</strong> We will inspect all items for visible damage and inform you of any issues before proceeding with service.
            </li>
            <li>
              <strong>Stains:</strong> Please pre-treat any stains or inform us of their presence. We will make reasonable efforts to remove stains, but cannot guarantee complete removal.
            </li>
          </ul>
        </li>
        <li>
          <strong>Sorting and Washing:</strong>
          <ul>
            <li>
              <strong>Sorting:</strong> Customers are responsible for sorting items by color and fabric type. We may sort items if needed but cannot be held liable for color bleeding or fabric damage.
            </li>
            <li>
              <strong>Detergent:</strong> We use commercial laundry detergent unless otherwise specified. If you require a specific detergent, leave a note before placing an order.
            </li>
          </ul>
        </li>
      </ol>

      <h2 className="terms-subheading">Dry Cleaning Service</h2>
      <ol>
        <li>
          <strong>Service Agreement:</strong> By using our dry cleaning service, you agree to these terms and conditions.
        </li>
        <li>
          <strong>Item Handling:</strong>
          <ul>
            <li>
              <strong>Inspection:</strong> All items will be inspected for visible damage before processing. We will notify you of any issues.
            </li>
            <li>
              <strong>Stains:</strong> Please pre-treat any stains or inform us of their presence. We will make reasonable efforts to address stains but cannot guarantee complete removal.
            </li>
          </ul>
        </li>
      </ol>
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <TermsAndConditions />
    </div>
  );
}

export default App;
